// Global constants
export const MOBILE_BREAKPOINT = 768;
